/**
 * @generated SignedSource<<82898e83f926d146e426a17643e64275>>
 * @relayHash f51c40dfa92d17d7239a399ce6697295
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa432e17de7b98c596088f453b7a09e73803d423d2293b28300ab73fb76ac5f2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "aa432e17de7b98c596088f453b7a09e73803d423d2293b28300ab73fb76ac5f2",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
